<template>
  <!--@formatter:off-->
    <div class="wrap">
        <div class="inner sub_survey editor">
            <div class="bx_notice_write bx_write">
                <SurveyEditorArticle v-if="article"/>
                <SurveyEditorContent v-else/>

                <div class="a_list">
                    <div class="set">
                        <h3 class="st">{{$t('SurveyEditor_responseTimeSettings')}}</h3>
                        <ul class="list_period">
                            <li>
                                <div class="info_lbl">{{$t('SurveyEditor_startDateTime')}}</div>
                                <div class="info_txt">
                                    <div class="reserve_message" :class="{disabled: isNotUseStartDate}">
                                        <TUIDatepickerInput
                                            id="startDate"
                                            v-model="startDate"
                                            :lang="$i18n.locale"
                                        />

                                        <CustomSelect
                                            class="bx_sorting2 hour"
                                            :options="select.hour.options"
                                            :is-show-arrow="false"
                                            :fit-width="false"
                                            v-model="startHour"
                                        />
                                        <span class="txt"> : </span>
                                        <CustomSelect
                                            class="bx_sorting2 minutes"
                                            :options="select.minute.options"
                                            :is-show-arrow="false"
                                            :fit-width="false"
                                            v-model="startMinute"
                                        />
                                    </div>
                                    <span class="bx_input_chk">
                                        <input type="checkbox" class="input_chk" id="sel_1" v-model="isNotUseStartDate"
                                               v-ga-helper:change="gaIsNotUseStartDate"
                                        >
                                        <label for="sel_1" class="input_lbl">{{$t('SurveyEditor_notUseStartDateTime')}}</label>
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="info_lbl">{{$t('SurveyEditor_endDateInfo')}}</div>
                                <div class="info_txt">
                                    <!-- [D] 데이트피커 -->
                                    <div class="reserve_message">
                                        <TUIDatepickerInput id="endDate" v-model="endDate" :lang="$i18n.locale"/>

                                        <CustomSelect class="bx_sorting2 hour" v-model="endHour" :options="select.hour.options" :is-show-arrow="false" :fit-width="false"/>
                                        <span class="txt"> : </span>
                                        <CustomSelect class="bx_sorting2 minutes" v-model="endMinute" :options="select.minute.options" :is-show-arrow="false" :fit-width="false" placement="bottom-end" />
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="a_list">
                    <div class="option_setting">
                        <ul>
                            <li>
                                <div class="info_head">
                                    <h3 class="st">{{$t('SurveyEditor_allowDenyOption')}}</h3>
                                    <span class="sp ico_help">
                                        {{$t('common_help')}}
                                        <span class="ly_tooltip_wrap" style="width: 282px; z-index: 1; margin-left: 22px; margin-top: -100px;">
                                            <span class="tit_help">{{$t('SurveyEditor_allowDenyOption')}}</span>
                                            <em class="tit_txt">{{$t('SurveyEditor_mustParticipate')}}</em>
                                            <span class="desc_txt">{{$t('SurveyEditor_mustParticipateDesc')}}</span>
                                            <em class="tit_txt">{{$t('SurveyEditor_optionalParticipate')}}</em>
                                            <span class="desc_txt">{{$t('SurveyEditor_optionalParticipateDesc')}}</span>
                                        </span>
                                    </span>
                                </div>
                                <div class="area_choice">
                                    <span class="bx_input_rdo">
                                        <input type="radio" name="set0" class="input_rdo" id="set0_1" :value="false"
                                               v-model="isAllowDeny"
                                               v-ga-helper:change="{
                                                 view_category: parentPageTitle,
                                                 view_area: '설문참여거절옵션클릭',
                                                 view_label: '무조건참여',
                                               }"
                                        >
                                        <label for="set0_1" class="input_lbl">{{$t('SurveyEditor_mustParticipate')}}</label>
                                    </span>
                                    <span class="bx_input_rdo">
                                        <input type="radio" name="set0" class="input_rdo" id="set0_2" :value="true"
                                               v-model="isAllowDeny"
                                               v-ga-helper:change="{
                                                 view_category: parentPageTitle,
                                                 view_area: '설문참여거절옵션클릭',
                                                 view_label: '선택적참여',
                                               }"
                                        >
                                        <label for="set0_2" class="input_lbl">{{$t('SurveyEditor_optionalParticipate')}}({{$t('SurveyEditor_rejectSurveyResponse')}})</label>
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="info_head">
                                    <h3 class="st">{{$t('SurveyEditor_allowEditOption')}}</h3>
                                    <span class="sp ico_help">
                                        {{$t('common_help')}}
                                        <span class="ly_tooltip_wrap" style="width: 282px; z-index: 1; margin-left: 22px; margin-top: -100px;">
                                            <span class="tit_help">{{$t('SurveyEditor_allowEditOption')}}</span>
                                            <span class="desc_txt" v-html="$t('SurveyEditor_allowEditOptionDesc')"></span>
                                            <em class="tit_txt">{{$t('SurveyEditor_editEnable')}}</em>
                                            <span class="desc_txt">{{$t('SurveyEditor_editEnableDesc')}}</span>
                                            <em class="tit_txt">{{$t('SurveyEditor_editDisable')}}</em>
                                            <span class="desc_txt">{{$t('SurveyEditor_editDisableDesc')}}</span>
                                        </span>
                                    </span>
                                </div>
                                <div class="area_choice">
                                    <span class="bx_input_rdo">
                                        <input type="radio" name="set5" class="input_rdo" id="option5_1" :value="true"
                                               v-model="isAllowEdit"
                                               v-ga-helper:change="{
                                                 view_category: parentPageTitle,
                                                 view_area: '응답자회신후수정옵션클릭',
                                                 view_label: '가능',
                                               }"
                                        >
                                        <label for="option5_1" class="input_lbl">{{$t('SurveyEditor_editEnable')}}</label>
                                    </span>
                                    <span class="bx_input_rdo">
                                        <input type="radio" name="set5" class="input_rdo" id="option5_2" :value="false"
                                               v-model="isAllowEdit"
                                               v-ga-helper:change="{
                                                 view_category: parentPageTitle,
                                                 view_area: '응답자회신후수정옵션클릭',
                                                 view_label: '불가능',
                                               }"
                                        >
                                        <label for="option5_2" class="input_lbl">{{$t('SurveyEditor_editDisable')}}</label>
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div class="info_head">
                                    <h3 class="st">{{$t('SurveyEditor_anonymityInfo')}}</h3>
                                </div>
                                <div class="area_choice">
                                    <span class="bx_input_rdo">
                                        <input type="radio" class="input_rdo" id="set2_1" :value="false" v-model="isAnonymity"
                                               v-ga-helper:change="{
                                                  view_category: parentPageTitle,
                                                  view_area: '익명설정옵션클릭',
                                                  view_label: '실명으로응답',
                                               }"
                                        >
                                        <label for="set2_1" class="input_lbl">{{$t('SurveyEditor_inRealName')}}</label>
                                    </span>
                                    <span class="bx_input_rdo">
                                        <input
                                            type="radio"
                                            class="input_rdo"
                                            id="set2_2"
                                            :disabled="hasParentCounselWeekQuestion"
                                            :value="true"
                                            v-model="isAnonymity"
                                            v-ga-helper:change="{
                                               view_category: parentPageTitle,
                                               view_area: '익명설정옵션클릭',
                                               view_label: '익명으로응답',
                                             }"
                                        >
                                        <label for="set2_2" class="input_lbl" @click="showAnonymityAlert">{{$t('SurveyEditor_anonymously')}}</label>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="a_list" v-if="showQuestion">
                    <SurveyEditorQuestionList ref="list"/>
                </div>


            </div>
        </div>

    </div>
    <!--@formatter:on-->
</template>

<script>
import TextInput from '@/iamteacherpc/components/common/TextInput.vue';
import TextArea from '@/iamteacherpc/components/common/TextArea.vue';
import DocumentUpload from '@/iamteacherpc/components/common/DocumentUpload.vue';
import TUIDatepickerInput from '@/iamteacherpc/components/common/TUIDatepickerInput.vue';
import CustomSelect from '@/iamteacherpc/components/common/CustomSelect.vue';
import ImageUpload from '@/iamteacherpc/components/common/ImageUpload.vue';
import Document from '@/iamteacherpc/components/common/Document.vue';
import store from '@/common/store';
import surveyEditorStore, {
    createInitForm,
    GET_PAYLOAD,
    GET_REQUEST_INFO,
    hasCondition,
    NAMESPACE,
    SET_ARTICLE,
    SET_FORM_DATA,
    SET_FORM_DATA_FROM_REQUEST_INFO,
    SET_REST_DAYS,
} from '@/common/store/modules/survey/editor.js';
import {mapFields} from 'vuex-map-fields';
import {REQUEST_STATE} from '@/iamteacherpc/consts/request.js';
import {createNamespacedHelpers} from 'vuex';
import SurveyEditorQuestionList from '@/iamteacherpc/components/editor/SurveyEditorQuestionList.vue';
import {iframeResizeEnd, iframeResizeStart, inIframe, requestAlert} from '@/iamteacherpc/utils/iframe.js';
import {LIST_CHANGE, STOP_LIST_CHANGE} from '@/common/store/modules/common/editor/questionList.js';
import SurveyEditorContent from '@/iamteacherpc/components/editor/SurveyEditorContent.vue';
import SurveyEditorArticle from '@/iamteacherpc/components/editor/SurveyEditorArticle.vue';
import {ANSWER_TYPE} from '@/common/consts/survey.js';
import {gaHelper} from '@iamteacherpc/utils/iframe';
import parentPageTitle from '@iamteacherpc/mixins/parentPageTitle';
import {availableSubQuestions, hasAnswer} from '@common/utils/question';
import usePromise from "@iamteacherpc/utils/usePromise";
import getValueFromPath from "@common/utils/getValueFromPath";
import ACCEPTED_DOMAIN from "@common/consts/accepted-domain";

if (!store.state[NAMESPACE]) {
    store.registerModule(NAMESPACE, surveyEditorStore);
}

const {mapGetters, mapActions} = createNamespacedHelpers(NAMESPACE);

export default {
    components: {
        SurveyEditorArticle,
        SurveyEditorContent,
        SurveyEditorQuestionList,
        Document,
        ImageUpload,
        CustomSelect,
        DocumentUpload,
        TextArea,
        TextInput,
        TUIDatepickerInput,
    },

    mixins: [parentPageTitle],

    metaInfo() {
        const title = this.$t('common_survey');
        return {title}
    },

    props: {
        showQuestion: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            select: {
                hour: {
                    options: (() => {
                        const options = [];
                        for (let i = 0; i < 24; i++) {
                            options.push({value: i, label: i < 10 ? '0' + i : '' + i});
                        }
                        return options;
                    })()
                },
                minute: {
                    options: (() => {
                        const options = [];
                        for (let i = 0; i < 60; i += 10) {
                            options.push({value: i, label: i === 0 ? '00' : '' + i});
                        }
                        return options;
                    })()
                }
            },
            UICompleted: null,
            isExistRequestRestDaysFuncInParentWindow: null,
            restDays: null,
            clearResolveFunc: null,
            resolveFunc: null,

            focusInEvent: {
                type: 'GENERATE_FOCUSIN_EVENT',
                targetOrigin: null,
            },
        }
    },

    watch: {
        startDate(newValue, oldValue) {
            this.gaHelperStartEndDate({
                newValue,
                oldValue,
                dateMsg: '시작일클릭',
                hourMsg: '시작시간클릭',
            })
        },

        endDate(newValue, oldValue) {
            this.gaHelperStartEndDate({
                newValue,
                oldValue,
                dateMsg: '마감일클릭',
                hourMsg: '마감시간클릭',
            })
        }
    },

    computed: {
        ...mapFields(NAMESPACE, [
            'form.title',
            'form.surveyDesc',
            'form.image',
            'form.isAllowDeny',
            'form.isAllowEdit',
            'form.documents',
            'form.startDate',
            'form.isUseStartDate',
            'form.endDate',
            'form.isAnonymity',
            'form.questions',
            'form.article',
        ]),

        ...mapGetters([
            GET_PAYLOAD,
            GET_REQUEST_INFO,
        ]),

        startHour: {
            get() {
                return this.startDate.getHours();
            },
            set(newValue) {
                const newDate = new Date(this.startDate);
                newDate.setHours(newValue);
                this.startDate = newDate;
            },
        },

        startMinute: {
            get() {
                return this.startDate.getMinutes();
            },
            set(newValue) {
                const newDate = new Date(this.startDate);
                newDate.setMinutes(newValue);
                this.startDate = newDate;
            },
        },

        isNotUseStartDate: {
            get() {
                return !this.isUseStartDate;
            },
            set(newValue) {
                this.isUseStartDate = !newValue;
            },
        },

        endHour: {
            get() {
                return this.endDate.getHours();
            },
            set(newValue) {
                const newDate = new Date(this.endDate);
                newDate.setHours(newValue);
                this.endDate = newDate;
            },
        },

        endMinute: {
            get() {
                return this.endDate.getMinutes();
            },
            set(newValue) {
                const newDate = new Date(this.endDate);
                newDate.setMinutes(newValue);
                this.endDate = newDate;
            },
        },

        hasParentCounselWeekQuestion() {
            return this.questions.some(q => q.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK);
        },
    },

    methods: {
        ...mapActions({
            stopListChange: STOP_LIST_CHANGE,
            listChange: LIST_CHANGE,
            storeSetFormData: SET_FORM_DATA,
            storeSetFormDataFromRequestInfo: SET_FORM_DATA_FROM_REQUEST_INFO,
            storeSetArticle: SET_ARTICLE,
            storeSetRestDays: SET_REST_DAYS,
        }),

        /**
         * ga 메소드
         */
        gaIsNotUseStartDate($event) {
            return {
                view_category: this.parentPageTitle,
                view_area: '시작일사용안함클릭',
                view_label: `사용안함(전송후바로설문)${$event.target.checked ? '' : '해제'}`
            }
        },

        gaHelperStartEndDate({newValue, oldValue, dateMsg, hourMsg}) {
            if (
                newValue.getYear() === oldValue.getYear() &&
                newValue.getMonth() === oldValue.getMonth() &&
                newValue.getDate() === oldValue.getDate()
            ) {
                if (
                    (newValue.getHours() !== oldValue.getHours()) ||
                    newValue.getMinutes() !== oldValue.getMinutes()
                ) {
                    gaHelper({
                        view_category: this.parentPageTitle,
                        view_area: hourMsg,
                        view_label: '',
                    })
                }
            } else {
                gaHelper({
                    view_category: this.parentPageTitle,
                    view_area: dateMsg,
                    view_label: '',
                })
            }
        },

        showAnonymityAlert() {
            if (this.hasParentCounselWeekQuestion) {
                requestAlert({
                    title: this.$t('SurveyEditor_dotNotAnonymouslyParentCounselWeek'),
                    okText: this.$t('common_confirm'),
                })
            }
        },

        onParentClick() {
            this.$eventBus.$emit('parentClick');
        },

        onParentFocus() {
            this.$eventBus.$emit('parentFocus');
        },

        getPayload() {
            return {
                ...this[GET_PAYLOAD]
            };
        },

        getRequestInfo() {
            return {
                ...this[GET_REQUEST_INFO]
            };
        },

        doFocus(elmId) {
            // 비동기 로직 에러, 상위 try catch에서 잡기위해 Promise reject 활용
            return new Promise((resolve, reject) => {
                // event 리스너의 순서에 영향을 받지 않기 위해 그냥 다음 콘트롤 플로우 떄 실행한다.
                setTimeout(() => {
                    this.$nextTick(() => {
                        try {
                            document.getElementById(elmId).focus();
                            this.listChange();
                            resolve();
                        } catch (e) {
                            reject(e);
                        }
                    });
                }, 0);
            })
        },

        formValidate() {
            this.stopListChange();

            const makeQuestionUICompletedFn = ({index, elmId}) => {
                // index가 잘못 설정되는 에러로인한 버그 발생
                // index 설정 로직 복잡함.. 당장 해결할 수 없기에 임시방편 해결책 - 재귀함수 활용
                return () => {
                    let initIndex = index;
                    const recur = async () => {
                        try {
                            this.$refs.list.setActiveEditorIndex(initIndex);
                            // doFocus 에러, 아래 catch에서 잡기위해 async await 활용
                            await this.doFocus(elmId);
                        } catch (e) {
                            initIndex -= 1;

                            // 무한반복을 막는 방어코드 : 수정창이 안뜨는것보다는 포커스가 안되는게 나음
                            if (initIndex < -10) {
                                return;
                            }
                            setTimeout(() => {
                                recur();
                            }, 100)
                        }
                    };
                    recur();
                };
            };

            const checkFCFSAnswers = ({question, questionNumber, firstDepthQuestionIndex}) => {
                for (let j = 0; j < question.answers.length; j++) {
                    const answer = question.answers[j];
                    if (!answer.limit) {
                        this.UICompleted = makeQuestionUICompletedFn({
                            index: firstDepthQuestionIndex,
                            elmId: `limit-${firstDepthQuestionIndex}-${j}`,
                        })

                        return {
                            isValid: false,
                            message: this.$t('SurveyQuestionEditor_inputLimitOfProgramNumberN', {
                                i: questionNumber,
                                j: j + 1,
                            }),
                        };
                    }
                }
            };

            const checkQuestions = ({
                                        questions,
                                        parentQuestionNumber = '',
                                        firstDepthQuestionIndex: _firstDepthQuestionIndex,
                                        startQuestionNumber = 1,
                                        startQuestionIndex = 0,
                                    }) => {
                let questionIndex = 0;

                for (let i = 0; i < questions.length; i++) {
                    const question = questions[i];

                    if (!question.isUseQuestion) {
                        continue;
                    }

                    const questionNumber = parentQuestionNumber/* string 임 */ + (startQuestionNumber + questionIndex);
                    let firstDepthQuestionIndex = _firstDepthQuestionIndex;
                    if (firstDepthQuestionIndex === undefined) {
                        firstDepthQuestionIndex = startQuestionIndex + questionIndex;
                    }

                    questionIndex++;

                    if (hasCondition(question) && !question.parentAnswerCondition.length) {
                        this.UICompleted = makeQuestionUICompletedFn({
                            index: firstDepthQuestionIndex,
                            elmId: `parentCondition${question.questionNo}${question.parentQuestion.answers[0].answerNo}`,
                        })
                        return {
                            isValid: false,
                            message: this.$t('SurveyEditor_selectDisplayOption', {n: questionNumber}),
                        };
                    }

                    if (!question.question) {
                        this.UICompleted = makeQuestionUICompletedFn({
                            index: firstDepthQuestionIndex,
                            elmId: `q${question.questionNo}`,
                        })
                        return {
                            isValid: false,
                            message: this.$t('SurveyEditor_inputQuestion', {n: questionNumber}),
                        };
                    }

                    if (hasAnswer(question)) {
                        for (let j = 0; j < question.answers.length; j++) {
                            const answer = question.answers[j];

                            if (!answer.text) {
                                this.UICompleted = makeQuestionUICompletedFn({
                                    index: firstDepthQuestionIndex,
                                    elmId: `a${answer.answerNo}`,
                                })
                                return {
                                    isValid: false,
                                    message: this.$t('SurveyEditor_inputExample', {i: questionNumber, j: j + 1}),
                                };
                            }
                        }
                    }

                    if (question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK_TIME) {
                        for (let j = 0; j < question.counselTimeSlots.length; j++) {
                            const timeSlot = question.counselTimeSlots[j];

                            if (!timeSlot) {
                                this.UICompleted = makeQuestionUICompletedFn({
                                    index: firstDepthQuestionIndex,
                                    elmId: `time-slot-${j}`,
                                })
                                return {
                                    isValid: false,
                                    message: this.$t('SurveyEditor_inputParentCounselTimeSlot', {n: questionNumber}),
                                }
                            }
                        }

                        const isAllDisabled = question.counselTimes
                            .flatMap(time => time)
                            .every(time => !time.value);

                        if (isAllDisabled) {
                            this.UICompleted = makeQuestionUICompletedFn({
                                index: firstDepthQuestionIndex,
                                elmId: `q${question.questionNo}`,
                            })
                            return {
                                isValid: false,
                                message: this.$t('SurveyEditor_setAtLeastOneTime', {n: questionNumber}),
                            }
                        }
                    }

                    if (availableSubQuestions({question})) {
                        let subQuestionsResult = null;

                        if (question.type === ANSWER_TYPE.TABLE) {
                            subQuestionsResult = checkQuestions({
                                questions: question.tableQuestions,
                                parentQuestionNumber: `${questionNumber}-`,
                            });
                        } else if (question.isParentFCFS) {
                            subQuestionsResult = checkFCFSAnswers({
                                question,
                                questionNumber,
                                firstDepthQuestionIndex,
                            });
                        } else if (question.type === ANSWER_TYPE.PARENT_COUNSEL_WEEK_TIME) {
                            subQuestionsResult = checkQuestions({
                                questions: question.questions,
                                parentQuestionNumber: `${questionNumber}-`,
                                firstDepthQuestionIndex: 0,
                            });
                        } else {
                            subQuestionsResult = checkQuestions({
                                questions: question.questions,
                                parentQuestionNumber: `${questionNumber}-`,
                                firstDepthQuestionIndex,
                            });
                        }

                        if (subQuestionsResult && !subQuestionsResult.isValid) {
                            return subQuestionsResult;
                        }
                    }
                }

                return {isValid: true};
            };

            if (!this.article) {
                if (!this.title) {
                    this.UICompleted = () => this.doFocus('title');
                    return {
                        isValid: false,
                        message: this.$t('SurveyEditorContent_inputSurveyTitle'),
                    };
                }

                if (!this.surveyDesc) {
                    this.UICompleted = () => this.doFocus('surveyDesc')
                    return {
                        isValid: false,
                        message: this.$t('SurveyEditorContent_inputSurveyDesc'),
                    };
                }

                const failDocument = this.documents.find(document => document.uploadState !== REQUEST_STATE.NONE && document.uploadState !== REQUEST_STATE.SUCCESS);
                if (failDocument) {
                    this.UICompleted = () => this.doFocus(failDocument.documentKey)
                    return {
                        isValid: false,
                        message: this.$t('common_thereIsUploadingDocument'),
                    };
                }
            }

            if (this.isUseStartDate && this.startDate <= new Date()) {
                this.UICompleted = () => this.doFocus('startDate')
                return {
                    isValid: false,
                    message: this.$t('SurveyEditor_startDateFasterNow'),
                };
            }

            if (this.endDate <= new Date()) {
                this.UICompleted = () => this.doFocus('endDate')
                return {
                    isValid: false,
                    message: this.$t('SurveyEditor_endDateFasterNow'),
                };
            }

            if (this.isUseStartDate && this.startDate >= this.endDate) {
                this.UICompleted = () => this.doFocus('startDate')
                return {
                    isValid: false,
                    message: this.$t('SurveyEditor_endDateFasterThanStartDate'),
                };
            }

            let questions = this.questions;
            let startQuestionNumber = 1;
            let startQuestionIndex = 0;
            if (this.questions[0].type === ANSWER_TYPE.PARENT_COUNSEL_WEEK) {
                const result = checkQuestions({
                    questions: questions[0].questions,
                    firstDepthQuestionIndex: 0,
                });

                if (!result.isValid) {
                    return result;
                }

                startQuestionNumber = 1 + questions[0].questions
                    .filter(question => question.isUseQuestion)
                    .length;

                startQuestionIndex = 1;
                questions = questions.slice(1);
            }

            const result = checkQuestions({
                questions,
                startQuestionNumber,
                startQuestionIndex,
            });

            if (!result.isValid) {
                return result;
            }

            this.listChange();

            return {
                isValid: true,
            };
        },

        formValidateTemp() {
            this.stopListChange();

            if (!this.article) {
                if (!this.title) {
                    this.UICompleted = () => this.doFocus('title')
                    return {
                        isValid: false,
                        message: this.$t('SurveyEditorContent_inputSurveyTitle'),
                    };
                }

                const failDocument = this.documents.find(document => document.uploadState !== REQUEST_STATE.NONE && document.uploadState !== REQUEST_STATE.SUCCESS);
                if (failDocument) {
                    this.UICompleted = () => this.doFocus(failDocument.documentKey)
                    return {
                        isValid: false,
                        message: this.$t('common_thereIsUploadingDocument'),
                    };
                }
            }

            this.listChange();

            return {
                isValid: true,
            };
        },

        async onMessageEvent(event) {
            switch (event.data.type) {
                case 'UI_COMPLETED':
                    this.UICompleted();
                    break;
                case 'SURVEY_EDITOR_VALIDATE':
                    window.parent.postMessage(
                        {
                            type: 'MAKE_REQUEST',
                            data: {
                                formValidateResult: event.data.type === 'TEMP' ? this.formValidateTemp() : this.formValidate(),
                            },
                        },
                        event.origin,
                    );
                    break;
                case 'RESULT_IS_EXIST_REQUEST_REST_DAYS_FUNC':
                    this.isExistRequestRestDaysFuncInParentWindow = event.data.data.result;
                    this.restDays = event.data.data.restDays;
                    this.resolveFunc.func();
                    this.clearResolveFunc();
                    break;
                case 'SET_FORM_DATA_FROM_REQUEST_INFO':
                    this.storeSetFormDataFromRequestInfo({requestInfo: event.data.data.requestInfo})
                    break;
                case 'SET_ARTICLE':
                    this.storeSetArticle({article: event.data.data.article})
                    break;
                case 'DISPATCH_CALL':
                    switch (event.data.data.type) {
                      case 'updateField':
                        if (event.data.data.payload.getField) {
                          await this.$store.dispatch(`${NAMESPACE}/${event.data.data.type}`, {
                            ...event.data.data.payload,
                            value: Array.isArray(event.data.data.payload.value) ?
                                event.data.data.payload.value.map(v => getValueFromPath(this.$store.getters[`${NAMESPACE}/getField`](v.question), v.index)) :
                                getValueFromPath(this.$store.getters[`${NAMESPACE}/getField`](event.data.data.payload.value.question), event.data.data.payload.value.index),
                          });
                        } else {
                          await this.$store.dispatch(`${NAMESPACE}/${event.data.data.type}`, event.data.data.payload);
                        }
                        break
                      case 'ADD_ANSWER':
                      case 'ADD_SUB_QUESTION':
                        await this.$store.dispatch(
                            `${NAMESPACE}/${event.data.data.type}`,
                            {
                              question: getValueFromPath(
                                  this.$store.getters[`${NAMESPACE}/getField`](event.data.data.payload.question),
                                  event.data.data.payload.index,
                              ),
                            }
                        );
                        break;
                      case 'ADD_QUESTION':
                      case 'ADD_PARENT_COUNSEL_WEEK':
                        await this.$store.dispatch(`${NAMESPACE}/${event.data.data.type}`);
                        break;
                      default:
                        break
                    }
                    window.parent.postMessage(
                        {
                            type: `RESULT_${event.data.type}`,
                        },
                        event.origin,
                    )
                    break;
                // [Todo] GET_FIELD_CALL 필요 없을 수도 있음
                case 'GET_FIELD_CALL':
                    window.parent.postMessage(
                        {
                            type: 'RESULT_GET_FIELD',
                            data: {
                                result: this.$store.getters[`${NAMESPACE}/getField`](event.data.data.path),
                            }
                        },
                        event.origin,
                    )
                    break;
                case 'GET_REQUEST_INFO':
                    window.parent.postMessage(
                        {
                            type: 'RESULT_GET_REQUEST_INFO',
                            data: {
                                getRequestInfo: this.getRequestInfo(),
                            }
                        },
                        event.origin,
                    )
                    break
                case 'REGISTER_FOCUSIN_EVENT':
                    this.focusInEvent.targetOrigin = event.origin;
                    window.addEventListener('focusin', this.sendToParentWindow);
                    break;
                case 'SET_SURVEY_DESC_HEIGHT':
                    document.querySelector(event.data.data.id).style.height = event.data.data.height + 'px';
                    window.parent.postMessage(
                        {
                            type: 'RESULT_SET_SURVEY_DESC_HEIGHT',
                        },
                        event.origin,
                    )
                    break;
                case 'CLICKED_PARENT':
                    this.onParentClick();
                    break
                case 'FOCUSED_PARENT':
                    this.onParentFocus();
                    break
                default:
                    break;
            }
        },

        sendToParentWindow() {
            window.parent.postMessage(
                {
                    type: this.focusInEvent.type,
                },
                this.focusInEvent.targetOrigin,
            )
        },
    },

    created() {
        if (inIframe()) {
            window.addEventListener('message', this.onMessageEvent);
            iframeResizeStart();
            try {
                // postMessage 먼저 보낼 때
                ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                    window.parent.postMessage(
                        {
                          type: 'REGISTER_PARENT_WINDOW_ON_PARENT_CLICK',
                        },
                        origin,
                    )
                    window.parent.postMessage(
                        {
                          type: 'REGISTER_PARENT_WINDOW_ON_PARENT_FOCUS',
                        },
                        origin,
                    )
                })
            } catch (e) {
              // ...
            }
            window.addEventListener('unload', () => {
                    // postMessage 먼저 보낼 때
                    ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                        window.parent.postMessage(
                            {
                              type: 'REMOVE_PARENT_WINDOW_ON_PARENT_CLICK',
                            },
                            origin,
                        )
                        window.parent.postMessage(
                            {
                              type: 'REMOVE_PARENT_WINDOW_ON_PARENT_FOCUS',
                            },
                            origin,
                        )
                    })
            });
            this.unsubscribeStore = this.$store.subscribe((mutation, state) => {
                if (mutation.type.indexOf('surveyEditor') === 0 && mutation.type.indexOf('setStopListChange') < 0) {
                    try {
                        // postMessage 먼저 보낼 때
                        ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                            window.parent.postMessage(
                                {
                                  type: 'SURVEY_FORM_CHANGED',
                                },
                                origin,
                            )
                        })
                    } catch (e) {
                        // ...
                    }
                }
            });
            this.$nextTick(async function () {
                try {
                    // postMessage 먼저 보낼 때
                    ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                        window.parent.postMessage(
                            {
                              type: 'IS_EXIST_REQUEST_REST_DAYS_FUNC',
                            },
                            origin,
                        )
                    })
                } catch (e) {
                    // ...
                }
                const {promiseInstance, clearResolveFunc, resolveFunc} = usePromise();
                this.clearResolveFunc = clearResolveFunc;
                this.resolveFunc = resolveFunc;
                const res = await promiseInstance();
                if (res === 'false') {
                    return;
                }

                if (this.isExistRequestRestDaysFuncInParentWindow) {
                    this.storeSetRestDays({restDays: this.restDays})
                }

                // postMessage 먼저 보낼 때
                ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                    window.parent.postMessage(
                        {
                          type: 'ON_SURVEY_CREATED',
                        },
                        origin,
                    )
                })
            });

            window.formValidate = this.formValidate;
            window.formValidateTemp = this.formValidateTemp;
            window.getPayload = this.getPayload;
            window.getRequestInfo = this.getRequestInfo;
        }
    },

    beforeDestroy() {
        if (inIframe()) {
            iframeResizeEnd();
            // postMessage 먼저 보낼 때
            ACCEPTED_DOMAIN[process.env.VUE_APP_TARGET_ORIGIN].forEach(origin => {
                window.parent.postMessage(
                    {
                      type: 'REMOVE_PARENT_WINDOW_ON_PARENT_CLICK',
                    },
                    origin,
                )
                window.parent.postMessage(
                    {
                      type: 'REMOVE_PARENT_WINDOW_ON_PARENT_FOCUS',
                    },
                    origin,
                )
            })
            window.removeEventListener('message', this.onMessageEvent);
            window.removeEventListener('focusin', this.sendToParentWindow);

            if (this.unsubscribeStore) {
                this.unsubscribeStore();
            }
        }
    }
}
</script>
